module.exports = __webpack_public_path__ + "img/shop_mb_tab_02.acf779f4.png";